/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_People_LabelInputs */

const th_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใครเข้าร่วมบ้าง`)
};

const en_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who is coming?`)
};

const ja_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`誰が参加しますか`)
};

const zh_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`谁会加入？`)
};

const es_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quién asiste?`)
};

const pt_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quem vai participar?`)
};

const id_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siapa yang ikut?`)
};

const fr_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qui participe ?`)
};

const tl_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sino ang sasali?`)
};

const vi_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ai sẽ tham gia?`)
};

const ko_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`누가 참여하나요?`)
};

const de_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wer kommt dazu?`)
};

const ru_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кто присоединится?`)
};

const tr_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kimler katılacak?`)
};

const it_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chi partecipa?`)
};

const pl_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kto dołączy?`)
};

const uk_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хто приєднається?`)
};

const hi_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कौन शामिल होगा?`)
};

const ar_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`من سينضم؟`)
};

const ms_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siapa akan menyertai?`)
};

const bn_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কারা যোগ দেবেন?`)
};

const zh_tw2_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`誰會參加？`)
};

const zh_hk2_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`誰會參加？`)
};

const ur_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کون شامل ہوگا؟`)
};

const fa_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`چه کسانی می‌پیوندند؟`)
};

const sw_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nani atajiunga?`)
};

const nl_meeting_people_label = /** @type {(inputs: Meeting_People_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie doet er mee?`)
};

/**
* | output |
* | --- |
* | "Who is coming?" |
*
* @param {Meeting_People_LabelInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_people_label = /** @type {((inputs?: Meeting_People_LabelInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_People_LabelInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_people_label(inputs)
	if (locale === "ja") return ja_meeting_people_label(inputs)
	if (locale === "zh") return zh_meeting_people_label(inputs)
	if (locale === "es") return es_meeting_people_label(inputs)
	if (locale === "pt") return pt_meeting_people_label(inputs)
	if (locale === "id") return id_meeting_people_label(inputs)
	if (locale === "fr") return fr_meeting_people_label(inputs)
	if (locale === "tl") return tl_meeting_people_label(inputs)
	if (locale === "vi") return vi_meeting_people_label(inputs)
	if (locale === "ko") return ko_meeting_people_label(inputs)
	if (locale === "de") return de_meeting_people_label(inputs)
	if (locale === "ru") return ru_meeting_people_label(inputs)
	if (locale === "tr") return tr_meeting_people_label(inputs)
	if (locale === "it") return it_meeting_people_label(inputs)
	if (locale === "pl") return pl_meeting_people_label(inputs)
	if (locale === "uk") return uk_meeting_people_label(inputs)
	if (locale === "hi") return hi_meeting_people_label(inputs)
	if (locale === "ar") return ar_meeting_people_label(inputs)
	if (locale === "ms") return ms_meeting_people_label(inputs)
	if (locale === "bn") return bn_meeting_people_label(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_people_label(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_people_label(inputs)
	if (locale === "ur") return ur_meeting_people_label(inputs)
	if (locale === "fa") return fa_meeting_people_label(inputs)
	if (locale === "sw") return sw_meeting_people_label(inputs)
	if (locale === "nl") return nl_meeting_people_label(inputs)
	return en_meeting_people_label(inputs)
});